{
  "_meta": {
    "_comment": "Phase 18 Wave 6 Task 34 — admin Vendor Detail > Integration tab. vg-binding: P18.D-21 | vg-binding: P18.D-28 | vg-binding: PLAN:task-34 || Phase 18 Wave 7 Task 36 — the ops.* subtree is the FLEET health widget on the vendors list (IntegrationHealthWidget.tsx). vg-binding: P18.D-13 | vg-binding: P18.D-35 | vg-binding: PLAN:task-36",
    "locale": "fr"
  },
  "tab": {
    "title": "Intégration",
    "description": "Clés API, point de terminaison webhook et journal de livraison pour la voie machine de ce vendeur."
  },
  "gate": {
    "heading": "Voie machine",
    "statusLabel": "État effectif",
    "effectiveOn": "Les clés peuvent appeler l'API",
    "effectiveOff": "Les appels sont refusés",
    "blockedLane": "L'interrupteur global de l'API vendeur est éteint : tous les vendeurs sont refusés, quel que soit cet interrupteur.",
    "blockedVendor": "L'intégration de ce vendeur est éteinte : ses clés sont refusées alors que la voie reste ouverte aux autres.",
    "laneLabel": "Voie globale",
    "vendorLabel": "Ce vendeur",
    "on": "Activée",
    "off": "Désactivée",
    "toggleOn": "Activer l'intégration",
    "toggleOff": "Désactiver l'intégration",
    "toggling": "Enregistrement…",
    "successOn": "Intégration activée",
    "successOff": "Intégration désactivée",
    "error": "Impossible de modifier l'interrupteur d'intégration",
    "readOnly": "Vous pouvez consulter l'intégration de ce vendeur, mais la modifier exige la permission de gestion des vendeurs."
  },
  "keys": {
    "title": "Clés API",
    "description": "Les clés que ce vendeur utilise pour appeler l'API vendeur. Les clés révoquées restent listées pour l'historique du support.",
    "create": "Créer une clé API",
    "creating": "Création…",
    "empty": "Ce vendeur n'a encore aucune clé API.",
    "labelLabel": "Libellé de la clé",
    "labelPlaceholder": "ex. système de production",
    "labelRequired": "Saisissez un libellé avant de créer la clé.",
    "columns": {
      "key": "Clé",
      "created": "Créée le",
      "lastUsed": "Dernière utilisation",
      "createdBy": "Créée par",
      "status": "Statut",
      "actions": "Actions"
    },
    "status": {
      "active": "Active",
      "revoked": "Révoquée"
    },
    "role": {
      "vendor_owner": "Propriétaire du vendeur",
      "admin": "Administrateur"
    },
    "never": "Jamais",
    "revoke": "Révoquer",
    "revoking": "Révocation…",
    "confirm": {
      "title": "Révoquer cette clé API ?",
      "description": "La clé cesse de fonctionner immédiatement et les propriétaires du vendeur sont notifiés. Action irréversible.",
      "confirmLabel": "Révoquer la clé"
    },
    "created": {
      "title": "Clé API créée",
      "description": "Copiez-la maintenant : elle n'est affichée qu'une seule fois et ne pourra plus être lue.",
      "warning": "Cette clé n'est affichée qu'une seule fois. Conservez-la en lieu sûr.",
      "copy": "Copier",
      "copied": "Copiée",
      "copyFailed": "Échec de la copie — sélectionnez le texte de la clé et copiez-le manuellement.",
      "saved": "J'ai enregistré cette clé",
      "done": "Terminé"
    },
    "toast": {
      "createdTitle": "Clé API créée",
      "createdBody": "Copiez la clé avant de quitter ce panneau.",
      "revokedTitle": "Clé API révoquée",
      "revokedBody": "La clé n'authentifie plus.",
      "errorTitle": "Échec de l'opération sur la clé"
    }
  },
  "webhook": {
    "title": "Point de terminaison webhook",
    "description": "Où ce vendeur reçoit les charges utiles d'événements.",
    "urlLabel": "URL du webhook",
    "noUrl": "Aucun point de terminaison enregistré.",
    "statusLabel": "Statut",
    "status": {
      "unset": "Non défini",
      "unverified": "Non vérifié",
      "verified": "Vérifié",
      "auto_disabled": "Désactivé automatiquement"
    },
    "verifiedAtLabel": "Vérifié le",
    "failuresLabel": "Échecs consécutifs",
    "vendorOnlyNote": "L'URL et le secret de signature sont modifiés par le vendeur dans son propre portail ; les administrateurs les consultent ici."
  },
  "deliveries": {
    "title": "Journal de livraison",
    "description": "Tentatives de webhook pour ce vendeur, les plus récentes d'abord.",
    "filterLabel": "Statut",
    "filterAll": "Tous les statuts",
    "status": {
      "delivered": "Livré",
      "retrying": "Nouvelle tentative",
      "failed": "Échec",
      "suppressed": "Supprimé"
    },
    "columns": {
      "event": "Événement",
      "status": "Statut",
      "attempts": "Tentatives",
      "lastAttempt": "Dernière tentative",
      "response": "Réponse"
    },
    "empty": "Aucune tentative de livraison enregistrée.",
    "previous": "Précédent",
    "next": "Suivant",
    "attemptsValue": "{{attempt}} / {{max}}",
    "noResponse": "Aucune réponse",
    "refreshing": "Actualisation…",
    "showing": "Affichage de {{count}} tentatives"
  },
  "ops": {
    "title": "Santé de l'intégration",
    "description": "Livraisons de webhooks vendeurs, tous vendeurs confondus, sur les {{hours}} dernières heures.",
    "loading": "Chargement de la santé de l'intégration…",
    "loadFailed": "Impossible de charger la santé de l'intégration : {{message}}",
    "retry": "Réessayer",
    "refreshing": "Actualisation…",
    "generatedAt": "Mesuré à {{time}}",
    "lane": {
      "label": "Flux sortant",
      "on": "Envoi actif",
      "off": "Envoi arrêté",
      "lane_disabled": "Le coupe-circuit de l'API vendeur est désactivé. Rien n'est envoyé et toute livraison marquée « suppressed » a été arrêtée volontairement — ce n'est pas une panne.",
      "dispatch_lane_off": "Le drapeau d'envoi des webhooks sortants est désactivé. Rien n'est envoyé et toute livraison marquée « suppressed » a été arrêtée volontairement — ce n'est pas une panne."
    },
    "events": {
      "failedLabel": "Événements en échec ({{hours}} h)",
      "ofSettled": "sur {{settled}} événements aboutis",
      "delivered": "Livrés",
      "retrying": "En cours de reprise",
      "suppressed": "Arrêtés volontairement",
      "suppressedNote": "Un événement compte une seule fois, quel que soit le nombre de tentatives. Les livraisons arrêtées par un interrupteur ne sont jamais comptées comme des échecs."
    },
    "vendors": {
      "label": "Vendeurs en échec",
      "value": "{{failing}} sur {{active}}"
    },
    "endpoints": {
      "label": "Endpoints désactivés automatiquement",
      "value": "{{count}} sur {{total}}",
      "vendors": "répartis sur {{count}} vendeurs"
    },
    "queue": {
      "label": "File de livraison",
      "value": "{{waiting}} en attente · {{active}} en cours · {{delayed}} différés",
      "unreachable": "File inaccessible",
      "paused": "File en pause"
    },
    "alert": {
      "warning": "Alerte à l'échelle de la flotte",
      "critical": "Incident à l'échelle de la flotte",
      "hint": "Une panne aussi large vient généralement de chez nous — vérifiez le worker de livraison, sa clé de signature et le DNS/TLS sortant avant de contacter les vendeurs.",
      "notified": "Une notification a été envoyée aux administrateurs à ce sujet.",
      "reason": {
        "fleet_failure_rate": "{{vendors}} vendeurs échouent en même temps — {{observed}} des événements aboutis sont en échec, au-delà du seuil de {{threshold}}.",
        "auto_disable_spike": "{{observed}} endpoints désactivés automatiquement chez {{vendors}} vendeurs, au-delà du seuil de {{threshold}}."
      }
    }
  },
  "errors": {
    "loadFailed": "Impossible de charger les données d'intégration : {{message}}",
    "retry": "Réessayer"
  },
  "common": {
    "loading": "Chargement…"
  }
}
